import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Box, Typography } from '@mui/material';
import { toSnakeCase } from '../promptUtils';

const COLOR = '#0891b2';

export default function GlobalToolsNode({ data, selected }) {
  const tools = data.tools || [];
  return (
    <Box sx={{
      position: 'relative',
      border: `2px solid ${COLOR}`,
      borderRadius: 2,
      width: 260,
      bgcolor: 'background.paper',
      boxShadow: selected ? `0 0 0 3px ${COLOR}44` : 1,
      overflow: 'hidden',
    }}>
      <Handle id="target-top" type="target" position={Position.Top} style={{ background: COLOR }} />
      <Handle id="target-left" type="target" position={Position.Left} style={{ background: COLOR }} />
      <Box sx={{ px: 1.5, py: 0.75, bgcolor: `${COLOR}22`, display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography sx={{ color: COLOR, fontWeight: 'bold', fontSize: 13 }}>⊕</Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold', color: COLOR, fontSize: 11 }}>Available Tools</Typography>
      </Box>
      <Box sx={{ px: 1.5, py: 0.75, display: 'flex', flexDirection: 'column', gap: 0.25 }}>
        {tools.length === 0
          ? <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 9 }}>No tools — add via properties</Typography>
          : tools.slice(0, 4).map((t) => (
            <Typography key={`${t.toolClass}.${t.methodName}`} variant="caption" sx={{ color: 'text.secondary', fontSize: 10, fontFamily: 'monospace' }}>
              ${toSnakeCase(t.toolClass)}.{t.methodName}()
            </Typography>
          ))
        }
        {tools.length > 4 && (
          <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 9 }}>+{tools.length - 4} more</Typography>
        )}
      </Box>
    </Box>
  );
}
